import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  notifications: [],
  unreadNotifications: [],
  notificationListOptions: {
    sort: {
      createdDate: 'asc',
    },
    limit: 0,
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
